export const RESET_CURRENT_LEAD = 'RESET_CURRENT_LEAD';

export function resetLead() {
  return {
    type: RESET_CURRENT_LEAD
  };
}
